import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { DeleteIcon } from 'foundations-assets';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
// @ts-expect-error Untyped Dependency

import { FiltersDisplay } from 'customer-data-filters-ui/public/components';
import { useMemo } from 'react';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomTile = styled.div.withConfig({
  displayName: "FilterTile__CustomTile",
  componentId: "jop1v9-0"
})(["", " &:hover{", " cursor:pointer;[data-test-id='journey-property-filter-delete-button']{display:initial;line-height:22px;}}[data-test-id='journey-property-filter-delete-button']{display:none;}"], ({
  theme
}) => {
  return {
    borderRadius: theme.borderRadius['100'],
    border: `1px solid ${theme.color['border-core-default']}`
  };
}, ({
  theme
}) => {
  return {
    backgroundColor: theme.color['fill-tertiary-hover']
  };
});
function FilterTile({
  filter,
  objectTypeId,
  editFilter,
  deleteFilter,
  strategy
}) {
  const filterValue = useMemo(() => {
    return {
      filterBranches: [{
        filterBranches: [],
        filterBranchOperator: 'AND',
        filterBranchType: 'AND',
        filters: [filter]
      }],
      filterBranchOperator: 'OR',
      filterBranchType: 'OR',
      filters: []
    };
  }, [filter]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(CustomTile, {
      onClick: editFilter,
      role: "button",
      "data-test-id": "journey-property-filter-tile",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        justifyContent: "space-between",
        padding: "200",
        children: [/*#__PURE__*/_jsx(FiltersDisplay, {
          baseFilterFamily: objectTypeId,
          strategy: strategy,
          value: filterValue
        }), /*#__PURE__*/_jsx(IconButton, {
          "data-test-id": "journey-property-filter-delete-button",
          use: "link",
          onClick: event => {
            event.stopPropagation();
            deleteFilter();
          },
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-enablement.reportEditors.journeyPropertyFilter.delete"
          }),
          placement: "right",
          children: /*#__PURE__*/_jsx(View, {
            as: "span",
            children: /*#__PURE__*/_jsx(DeleteIcon, {})
          })
        })]
      })
    })
  );
}
export default FilterTile;